import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  private requests: HttpRequest<any>[] = [];

  constructor(private spinnerService: NgxSpinnerService) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    if (this.requests.length === 0) {
      this.spinnerService.hide();
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.removeRequest(req);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.removeRequest(req);
        throw error;
      }),
      finalize(() => {
        this.removeRequest(req);
      })
    );
  }
}
